import React from 'react';
import {Grid} from "@material-ui/core";
import {Garlic, starFill, featureProduct} from "../../../assets/images/images";
import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import Typography from "@material-ui/core/Typography";
import {makeStyles} from "@material-ui/core/styles";
import {Heading24} from '../../'
import { APP_DOMAIN_PREFIX } from '../../../environment';


const useStyles = makeStyles({
  root: {
    // maxWidth: 200,
    // margin:20,
    // display:'flex',
    // flexDirection:'column',
    // alignItems:'center',
    // padding:20,
    // borderRadius:4,
    // width:500,
    background: 'transparent'
  },
});

function FeatureProCard(props) {
  const classes = useStyles();
  let position = props?.item?.imagePath?.search("userImages");
  let imageUrl = APP_DOMAIN_PREFIX + props.item.imagePath;
  if(position == -1)
   imageUrl = APP_DOMAIN_PREFIX + "/userImages/" + props.item.imagePath;
  return (

    <Card className={classes.root}>
      <div className='display-flex  align-items-center ' style={{}}>

        <div className='pr-20' style={{width:'60%'}}>
          <p className='heading-color font-12 ls-10'>BEST SELLER</p>
          <Heading24 title={props.item && props.item.harvest? props.item.harvest: ''}/>
          <p className='mt-10 mb-10 heading-color font-10'>Delivery all over Pakistan</p>
          <div className='font-12 heading-color display-flex align-items-center'>
            {/*<span className='heading-color p-20' style={{fontSize:50}}>| </span>*/}
            <span className='heading-color pl-10 ml-5 font-12' style={{borderLeft:'1px solid'}}>{props.item.description} </span>
          </div>
          <Grid container direction='row' alignItems='center'>
            <Grid>
              <Heading24 title={props.item && props.item.priceSetByVendor? props.item.currency + props.item.priceSetByVendor: ''}/>
            </Grid>
            {/* <Grid className='ml-10 '>
              <p className='m-0 font-14 red-color line-through'>{props.item && props.item.priceSetByVendor? props.item.currency + props.item.priceSetByVendor: ''}</p>

            </Grid>
            <Grid className='ml-10'>
              <p className='m-0 font-10 heading-color'>{props.item && props.item.priceSetByVendor? props.item.currency + props.item.priceSetByVendor: ''}</p>
            </Grid> */}
          </Grid>
          <Grid container direction='row'>
            {/* <Grid>
              <button  className='buy-btn bg-discount white-color' style={{}}>buy now</button>
            </Grid> */}
            <Grid className='ml-10'>
              <button className='buy-btn heading-color text-bold' onClick={props.onClick}>see details</button>
            </Grid>
          </Grid>
        </div>
        <div className='max-width-50'><img src={props.item && imageUrl || featureProduct} className='feature-product-img'/></div>
      </div>
    </Card>

  );
}

export default FeatureProCard;
